module.exports = __webpack_public_path__ + "img/icon-temporary-residents.e2709da0.svg";